




import { Component, Prop, Vue } from 'vue-property-decorator';
import State from '@/ts/game/state';

import firebase from 'firebase/app';

@Component
export default class Game extends Vue {
  private state?: State;
  private tokenPromise?: Promise<string>;

  public created() {
    this.tokenPromise = firebase.auth().currentUser!!.getIdToken();
  }

  public async mounted() {
    const state = new State(this.$refs.ui as HTMLElement, this.$el.clientWidth, this.$el.clientHeight);
    await state.start(this.tokenPromise!!);
    this.state = state;

    window.addEventListener('resize', this.handleResize);
  }

  public handleResize() {
    if (this.state) {
      this.state.resize(this.$el.clientWidth, this.$el.clientHeight);
    }
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  public destroyed() {
    if (this.state) {
      this.state.stop();
    }
  }
}
